import React, { useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import EmailForm from './EmailForm';
import { useWebContent } from '../hooks/useWebContent'; // dynamic footer-section data

//Import Footer SVg
import {FooterSVG} from '../components/SvgIcons';

const Footer = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Fetch web content using the hook
  const {
    data: webContent,
    isLoading: isContentLoading,
    isError: isContentError,
    error: contentError,
  } = useWebContent();

  // Default static values for footer content fallback
  const defaultData = {
    title: 'Vidyakasam – Smart Exam Prep',
    buttons: [
      { url: '#', image: null },
      { url: '#', image: null },
    ],
    quick_links: [
      { url: '#', icon: null },
      { url: '#', icon: null },
      { url: '#', icon: null },
      { url: '#', icon: null },
    ],
    section_image: null,
    newsletter_message:
      'Subscribe our newsletter to receive latest updates regularly from us!',
    copyright_text: `© Copyrights ${new Date().getFullYear()}. All rights reserved.`,
    designed_and_developed_by:
      'Design & Developed by VidyaKasam Education Pvt Ltd',
    heading_text_1: 'Need Support',
    heading_text_2: 'Support',
    heading_text_3: 'Need Support',
  };

  // Extract footer-section data
  const footerSection = webContent?.dataset?.data?.['footer-section']?.json_data;

  if (!footerSection) return null;

  // Dynamic data from footer-section
  const sectionData = {
    title: footerSection?.title || defaultData.title,
    buttons: footerSection?.buttons || defaultData.buttons,
    quick_links: footerSection?.quick_links || defaultData.quick_links,
    section_image: footerSection?.section_image || defaultData.section_image,
    newsletter_message:
      footerSection?.newsletter_message || defaultData.newsletter_message,
    copyright_text:
      footerSection?.copyright_text || defaultData.copyright_text,
    designed_and_developed_by:
      footerSection?.designed_and_developed_by ||
      defaultData.designed_and_developed_by,
    heading_text_1: footerSection?.heading_text_1 || defaultData.heading_text_1,
    heading_text_2: footerSection?.heading_text_2 || defaultData.heading_text_2,
    heading_text_3: footerSection?.heading_text_3 || defaultData.heading_text_3,
  };

  if (isContentLoading) return <div>Loading...</div>;
  if (isContentError) return <div>Error: {contentError?.message}</div>;

  return (
    <>
      <footer className="footer footer-svg" data-aos="fade-in" data-aos-duration="1500">
        <div className="svg-position svg-img" style={{ paddingTop: '210px' }}>
          {/* --- Big SVG background start --- */}
           <FooterSVG/>
          {/* --- Big SVG background end --- */}

          <div className="svg-content">
            <Container>
              <Row>
                {/* Left column: logo + title + app buttons */}
                <div className="col-lg-5 col-md-6 col-12">
                  <div className="footer-column1">
                    <div className="logo">
                      <img
                        src={sectionData.section_image || require('../assets/images/footer-logo.png')}
                        alt="Logo"
                        data-aos="fade-in"
                        data-aos-duration="1500"
                      />
                    </div>
                    <p className="mb-0 logo-p" data-aos="fade-in" data-aos-duration="1500">
                      {sectionData.title}
                    </p>
                    <div className="app-buttons dwn-btns">
                      {sectionData.buttons.map((button, index) => (
                        <a
                          key={index}
                          href={button.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-aos="fade-in"
                          data-aos-duration="1500"
                          data-aos-delay={100 * index}
                        >
                          <img
                            src={button.image || require(`../assets/images/dwn${index + 1}.png`)}
                            alt=""
                          />
                        </a>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Middle column: quick internal links */}
                <div className="col-lg-2 col-md-6 col-12">
                  <div className="links" data-aos="fade-in" data-aos-duration="1500">
                    <h3>{sectionData.heading_text_1}</h3>
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/about-us">About Us</Link></li>
                      <li><Link to="/features">Features</Link></li>
                      <li><Link to="/blog">Blog</Link></li>
                      <li><Link to="/contact">Contact</Link></li>
                    </ul>
                  </div>
                </div>

                {/* Middle column: policy links → navigate to pages (no modals) */}
                <div className="col-lg-2 col-md-6 col-12">
                  <div className="links" data-aos="fade-in" data-aos-duration="1500">
                    <h3>{sectionData.heading_text_2}</h3>
                    <ul>
                      <li><Link to="/terms-and-conditions" style={{ color: '#fff' }}>Terms & Conditions</Link></li>
                      <li><Link to="/privacy-policy" style={{ color: '#fff' }}>Privacy Policy</Link></li>
                      <li><Link to="/payment-disclaimer" style={{ color: '#fff' }}>Payment Disclaimer</Link></li>
                      <li><Link to="/refund-policy" style={{ color: '#fff' }}>Refund Policy</Link></li>
                    </ul>
                  </div>
                </div>

                {/* Right column: newsletter */}
                <div className="col-lg-3 col-md-6 col-12">
                  <h3 data-aos="fade-in" data-aos-duration="1500">{sectionData.heading_text_3}</h3>
                  <p className="agree-text" data-aos="fade-in" data-aos-duration="1500">
                    {sectionData.newsletter_message}
                  </p>
                  <EmailForm />
                  <p className="agree-text" data-aos="fade-in" data-aos-duration="1500">
                    By clicking send link you agree to receive message.
                  </p>
                </div>
              </Row>
            </Container>

            {/* COPYRIGHT SECTION */}
            <div className="copyright">
              <Container>
                <Row>
                  <div className="col-md-4">
                    <p className="mb-0">{sectionData.copyright_text}</p>
                  </div>
                  <div className="col-md-4">
                    <ul className="social-icons mb-0">
                      {sectionData.quick_links.map((link, index) => (
                        <li key={index}>
                          <a href={link.url} target="_blank" rel="noopener noreferrer">
                            {link.icon ? (
                              <img src={link.icon} alt="Social Icon" className="social-icon" />
                            ) : (
                              <i
                                className={`fa-brands fa-${
                                  index === 0 ? 'facebook-f'
                                    : index === 1 ? 'x-twitter'
                                    : index === 2 ? 'instagram'
                                    : 'pinterest-p'
                                }`}
                                aria-hidden="true"
                              ></i>
                            )}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <p className="mb-0">{sectionData.designed_and_developed_by}</p>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;



